import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { ThumbDown, ThumbUp } from "@material-ui/icons";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { useTtmsAuth } from "@tt/ttms-react-core";
import React from "react";
import { useDataProvider, useNotify } from "react-admin";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: "wrap",
  },
  divider: {
    margin: theme.spacing(1, 0.5),
  },
}));

const StyledToggleButtonGroup = withStyles((theme) => ({
  grouped: {
    margin: theme.spacing(0.5),
    border: "none",
    "&:not(:first-child)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-child": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}))(ToggleButtonGroup);

export default function CustomizedDividers(props: any) {
  const dp = useDataProvider();
  const notify = useNotify();
  const { user } = useTtmsAuth();
  const classes = useStyles();

  const [alignment, setAlignment] = React.useState("left");
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  //#region Interaction: Like ve Dislike kayıt işlemi yapılıyor.
  const handleClick = async (value, selected) => {
    await dp
      .create("Interactions", {
        data: {
          videoId: props.record.id,
          vote: selected == false ? value : 0,
        },
        //Örneğin lile üzerinden not bırakayım. Aynısı dislike içinde geçerlidir.
        //Video'yu beğendiysen ve like tuşuna bastığında selected == false olarak gelir. Yani şu an like değil şimdi kaydet demek oluyor.
        //Eğer şuan like olarak işaretlendiysen ve sen like'ı iptal etmek istiyorsan da selected==true olarak gelir. O da ben şu an selected'ım ama sen iptal ediyorsun anlamına geliyor.
      })
      .then(() => {
        if (value == 1) {
          notify(selected == false ? "Beğenilen videolara eklendi" : "Beğenilen videolardan kaldırıldı");
        } else if (value == -1) notify(selected == false ? "Bu videoyu beğenmediniz" : "Beğenmeme kaldırıldı");
      })
      .catch((error) => {
        notify("beğen ve beğenmeme tuşlarında hata var!", "warning");
      });

    //interaction alanları refresh ediliyor.
    await getInteraction();
  };
  //#endregion

  //#region Video Record sayısını buluyorum..
  const [videoRecord, setvideoRecord] = React.useState(0);
  const [interactionThumbUp, setinteractionThumbUp] = React.useState(false);
  const [interactionThumbDown, setinteractionThumbDown] = React.useState(false);

  React.useEffect(() => {
    (async function () {
      await getVideoRecord();
      await getInteraction();
    })();
  }, [dp]);

  const getVideoRecord = async () => {
    const data = await dp.getList("VideoRecords", {
      pagination: { page: 1, perPage: 50 },
      sort: { field: "id", order: "ASC" },
      filter: { videoId__eq: props.record.id },
    });

    setvideoRecord(data.total);
  };

  const getInteraction = async () => {
    const { data } = await dp.getList("Interactions", {
      pagination: { page: 1, perPage: 1 },
      sort: { field: "id", order: "ASC" },
      filter: {
        videoId__eq: props.record.id,
        createdBy__eq: user?.employeeId,
      },
    });

    if (data.length > 0) {
      setinteractionThumbUp(data[0].vote == 1 ? true : false);
      setinteractionThumbDown(data[0].vote == -1 ? true : false);
    }
  };
  //#endregion

  return (
    <div>
      <Paper elevation={0} className={classes.paper}>
        <StyledToggleButtonGroup>
          <ToggleButton selected={false} value="videoRecordsTotal">
            {videoRecord} views
          </ToggleButton>
        </StyledToggleButtonGroup>
        <Divider flexItem orientation="vertical" className={classes.divider} />
        <StyledToggleButtonGroup value={alignment} exclusive onChange={handleAlignment}>
          <ToggleButton
            value="1"
            onClick={(e) => handleClick(1, interactionThumbUp)}
            aria-label="right aligned"
            selected={interactionThumbUp}
            //title={interactionThumbUp == false ? "Bunu beğendim" : "Beğenmekten vazgeç"}
          >
            <ThumbUp />
          </ToggleButton>
          <ToggleButton
            value="-1"
            onClick={(e) => handleClick(-1, interactionThumbDown)}
            aria-label="right aligned"
            selected={interactionThumbDown}
            //title={interactionThumbDown == false ? "Bunu beğenmedim" : "Beğenmemekten vazgeç"}
          >
            <ThumbDown />
          </ToggleButton>
        </StyledToggleButtonGroup>
      </Paper>
    </div>
  );
}
